import { render, staticRenderFns } from "./MedicalOrganizationsDictionary.vue?vue&type=template&id=121456c6&lang=pug&"
import script from "./MedicalOrganizationsDictionary.vue?vue&type=script&lang=js&"
export * from "./MedicalOrganizationsDictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports